import { render, staticRenderFns } from "./header.vue?vue&type=template&id=db7cebd6&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=db7cebd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7cebd6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavMobile: require('D:/Project/kpwebsite/H5/components/nav/navMobile.vue').default})
